import { observer } from 'mobx-react';
import { FC, MouseEvent, useCallback } from 'react';
import { ICustomerProfile } from '../../../CustomerProfileEditScreen/types';
import { customersProfilesStore } from '../../store';
import CustomersProfilesListRowDate from '../CustomersProfilesListRowDate/CustomersProfilesListRowDate';
import { SCREENS } from 'src/constants/screens';
import { history } from 'src/services/history';
import { TBooleanInNumber } from 'src/types/main';
import Text, { TEXT } from 'src/view/components/Text/Text';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import './style.scss';

interface IProps {
  customer: ICustomerProfile;
}

const CustomersProfilesListRow: FC<IProps> = observer(({ customer }: IProps): JSX.Element => {
  const onEditCustomer = () => {
    history.push(SCREENS.CRM_PROFILE_EDIT(customer.id));
  };

  const onActionBlockClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  const onStatusChange = useCallback(
    (status: TBooleanInNumber) => {
      customersProfilesStore.changeStatus(customer.id, status);
    },
    [customer]
  );

  return (
    <div onClick={onEditCustomer} className="customers-profiles-list-row customers-profiles-list-row__grid-template mr-4">
      <div className="customers-profiles-list-row__element">
        <Text type={TEXT.LIST_ROW} text={customer.name} noTranslate />
      </div>

      <div className="customers-profiles-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={customer.mobile} noTranslate />
      </div>

      <CustomersProfilesListRowDate customer={customer} dateType="first" />

      <CustomersProfilesListRowDate customer={customer} dateType="last" />

      <CustomersProfilesListRowDate customer={customer} dateType="registration" />

      <div className="customers-profiles-list-row__element">
        <Text type={TEXT.LIST_ROW} text={customer.order_total_sum} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Text type={TEXT.LIST_ROW} text={customer.order_total_count} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Text type={TEXT.LIST_ROW} text={customer.order_total_avg} />
      </div>

      <div onClick={onActionBlockClick} className="customers-profiles-list-row__element cursor-default">
        <Switcher status={customer.status} onChange={onStatusChange} />
      </div>
    </div>
  );
});

export default CustomersProfilesListRow;
